<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfDonem from "@/models/StrPerfDonem";
import AddEdit from "./AddEdit.vue";
import StrPerfDonemAlt from "./StrPerfDonemAlt.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";

export default {
  mixins: [Api, Sabit, StrPerfDonem],
  page: {
    title: "Plan Dönemleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    StrPerfDonemAlt,
    AddEdit,
    formcombobox
  },
  data() {
    return {
      title: this.$t("StrPerfDonem.Title"),
      items: [
        {
          text: this.$t("StrPerfDonem.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrPerfDonem.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrPerfDonem.Title"),
          active: true,
        },
      ],
      islem: "",
      FilitrelemePenceresi: false,
      TableData: [],
      SiradakiNo: 0,
      DataUpdate: "",
      FormTitle: "",
      BagliOlduguDonem: "",
      PerfDonemleri: [],
      veriler: {},
      islem_durum: false,
      sayac: 0,
      DefaultPage: 1,
      AddEdit: "",
      UstKontrol: "0",
      TipId:null,
      min_tarih: "",
      max_tarih: "",
      min_yilbas: "",
      min_yilbit: "",
      max_yilbit: "",
      Guncelleme: 0,
      kontrol:0,

      Filter: {
        Aciklama: "",
        TipId:"",
        BaslamaTarihi: "",
        BitisTarihi: "",
        UstIdDoluMu: false,
      },
      siralama:"&Desc=BaslamaTarihi",

      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },

  methods: {
    UpdateStr(data) {
      this.DataUpdate = data;
      console.log(data)
      
      for (var i=0; i<this.TableData.length; i++)
      {
        if (this.TableData[i].Id==data.UstId){

          this.TipId=this.TableData[i].TipId;
          this.UstKontrol = '0';
        }
      }

    },

    islemAlt(islem) {
      this.AddEdit = islem;
  
    },

    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let ustidler = [];
      let liste = [];

      this.ActionsGet({ Service: "StrPerfDonem", Page: Page }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          if (res.Data[i].UstId != "" && res.Data[i].UstId != null) {
            ustidler.push(res.Data[i].UstId);
          }
        }

        this.Guncelleme += 1;

        let Filter = "&UstIdDoluMu=" + this.Filter.UstIdDoluMu;

        if (this.Filter.Aciklama != "" && this.Filter.Aciklama != null) {
          Filter = Filter + "&Aciklama=" + this.Filter.Aciklama;
        }
        if (this.Filter.TipId != "" && this.Filter.TipId != null) {
          Filter = Filter + "&TipId=" + this.Filter.TipId;
        }
        if (this.Filter.BaslamaTarihi != "" && this.Filter.BaslamaTarihi != null) {
          Filter = Filter + "&BaslamaTarihi=" + this.Filter.BaslamaTarihi;
        }
        if (this.Filter.BitisTarihi != "" && this.Filter.BitisTarihi != null) {
          Filter = Filter + "&BitisTarihi=" + this.Filter.BitisTarihi;
        }

        

      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }


        this.ActionsFilterGet({ Service: "StrPerfDonem", Page: this.Page, Filter: Filter }).then((res) => {
          liste = res.Data;


          for (i = 0; i < liste.length; i++) {
            var varmi = ustidler.indexOf(liste[i].Id);
            if (varmi >= 0) {
              liste[i].sil = 0;
            } else {
              liste[i].sil = 1;
            }
          }

          this.TableData = liste;

          this.Page.PageDataSize = res.TotalCount;
        });
      });
    },

    formkontrol() {
      this.$bvModal.show("StrPerfDonem");
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                     <input @input="Filter.Aciklama.length >= 3 || Filter.Aciklama.length == 0 ? Get() : ''" 
                    v-model="Filter.Aciklama" type="text" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrPerfDonem.Page.Filtreleme") }}</button>
                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" @click="formkontrol(), (StrPerfDonemData.UstId = ''), (DataUpdate = StrPerfDonemData), (AddEdit = 'Add'), (UstKontrol = '1'),(TipId=null)"><i class="mdi mdi-plus me-1"></i> {{ this.$t("StrPerfDonem.Page.YeniKayitEkle") }}</button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th></th>

                    <th scope="col">{{ $t("StrPerfDonem.Table.TipValue") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=TipValue'" @click="siralama='&Asc=TipValue', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=TipValue'" @click="siralama='&Desc=TipValue', Get()" class="bx bx-sort-z-a  fa-xl"></i> 
                    </th>
                    <th scope="col">{{ $t("StrPerfDonem.Table.Aciklama") }}
                    <i style="margin-left:10px" v-if="siralama!='&Asc=Aciklama'" @click="siralama='&Asc=Aciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Aciklama'" @click="siralama='&Desc=Aciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th scope="col">{{ $t("StrPerfDonem.Table.BaslamaTarihi") }}
                    <i style="margin-left:10px" v-if="siralama!='&Asc=BaslamaTarihi'" @click="siralama='&Asc=BaslamaTarihi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=BaslamaTarihi'" @click="siralama='&Desc=BaslamaTarihi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th scope="col">{{ $t("StrPerfDonem.Table.BitisTarihi") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=BitisTarihi'" @click="siralama='&Asc=BitisTarihi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=BitisTarihi'" @click="siralama='&Desc=BitisTarihi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th style="width: 120px; text-align: center; vertical-align: middle;">{{ $t("StrPerfDonem.Table.Approval") }}
                    <i style="margin-left:10px" v-if="siralama!='&Asc=Approval'" @click="siralama='&Asc=Approval', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Approval'" @click="siralama='&Desc=Approval', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th style="width: 120px; text-align: center; vertical-align: middle;">{{ $t("StrPerfDonem.Table.Hedefmi") }}
                    <i style="margin-left:10px" v-if="siralama!='&Asc=Hedefmi'" @click="siralama='&Asc=Hedefmi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Hedefmi'" @click="siralama='&Desc=Hedefmi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th style="width: 100px; text-align: center; vertical-align: middle;">{{ $t("StrPerfDonem.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody v-for="Data in TableData" :key="Data.Id">
                  <tr v-if="!Data.UstId">
                    <th scope="row" class="custom-accordion">
                      <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" v-b-toggle="'CollapseAltTablo' + Data.Id" role="button" aria-expanded="false" aria-controls="categories-collapse">
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>

                    <td> {{ Data.TipValue }}</td>
                    <td>{{ Data.Aciklama }}</td>
                    <td>{{ Data.BaslamaTarihi | formatDateTable }}</td>
                    <td>{{ Data.BitisTarihi | formatDateTable }}</td>
                    <td style="width: 90px; text-align: center; vertical-align: middle;">
                      <i v-if="Data.Approval" class="fas fas fa-check"></i>
                      <i v-if="!Data.Approval" class="fas fas fa-times"></i>
                    </td>
                    <td style="width: 90px; text-align: center; vertical-align: middle;">
                      <i v-if="Data.VeriTipi==2" class="fas fas fa-check"></i>
                      <i v-if="Data.VeriTipi!=2" class="fas fas fa-times"></i>
                    </td>
                    <td style="width: 85px; text-align: center; vertical-align: middle;">
                    
                      <b-button-group>

                        <b-button variant="success" v-b-modal.StrPerfDonem 
                        @click=" (AddEdit = 'Add'), 
                        (UstKontrol = '0'), (min_tarih = Data.BaslamaTarihi), 
                        (max_tarih = Data.BitisTarihi), (min_yilbas = Data.YilBas.toString()), 
                        (max_yilbit = Data.YilBit.toString()), (StrPerfDonemData.UstId = Data.Id),
                        (DataUpdate = StrPerfDonemData),(TipId=Data.TipId),(kontrol=kontrol+1)">
                        <i class="fas fa-plus"></i></b-button>

                        <b-button variant="primary" v-b-modal.StrPerfDonem @click="(DataUpdate = Data), (AddEdit = 'Edit'), (UstKontrol = '1'), (min_tarih = 0), (max_tarih = 0), (min_yilbas = '2000'), (max_yilbit = '2100'),(TipId=null)"><i class="fas fa-pencil-alt"></i></b-button>
                        <b-button variant="danger" v-if="Data.sil == 1" @click="Delete('StrPerfDonem', Data.Id)"><i class="fas fa-trash-alt"></i></b-button>
                      </b-button-group>
                    </td>
                  </tr>

                  <tr>
                    <td></td>
                    <td colspan="8">
                      <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.Id">

                        <StrPerfDonemAlt 
                        :TanimId="Data.Id" 
                        :Guncelle="Guncelleme" 
                        @DataUpdate="UpdateStr($event)" 
                        @AddEdit="islemAlt($event)" 
                        @min_tarih="min_tarih = $event" 
                        @max_tarih="max_tarih = $event" 
                        @min_yilbas="min_yilbas = $event" 
                        @max_yilbit="max_yilbit = $event" />
                      
                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>

              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" 
      :AddEdit="AddEdit" 
      :kontrol="kontrol"
      :min_tarih="min_tarih" 
      :max_tarih="max_tarih" 
      :min_yilbas="min_yilbas" 
      :max_yilbit="max_yilbit" 
      :TipId="TipId"
      @TableUpdate="Get()" :UstKontrol="UstKontrol" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrPerfDonem.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrPerfDonem.Filtreleme.Content") }}
            <hr />

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfDonem.Filtreleme.Aciklama") }}</label>
              <b-form-input for="text" v-model="Filter.Aciklama" value=""></b-form-input>
            </div>

            <div class="mb-3 ">
                    <formcombobox
                        :title_position="'d-block'"
                        :labels_lg="6"
                        :FormDataType="FormDataType.TipId"
                        :Value="Filter.TipId"
                        :v="$v.FormData.TipId"
                        @input="Filter.TipId = $event"
                      />  
            </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfDonem.Filtreleme.BaslamaTarihi") }}</label>
              <b-form-input id="datebs" v-model="Filter.BaslamaTarihi" value="" type="date"></b-form-input>
            </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfDonem.Filtreleme.BitisTarihi") }}</label>
              <b-form-input id="datebs" v-model="Filter.BitisTarihi" value="" type="date"></b-form-input>
            </div>

            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrPerfDonem.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
